import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import RoutesPage from './pages/Routes';
import Issues from './pages/Issues';
import Reports from './pages/Reports';
import SystemIntel from './pages/SystemIntel';
import Settings from './pages/Settings';
import './index.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="vehicles" element={<Vehicles />} />
          <Route path="routes" element={<RoutesPage />} />
          <Route path="issues" element={<Issues />} />
          <Route path="reports" element={<Reports />} />
          <Route path="intel" element={<SystemIntel />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;